export const LOGIN_WITH_OTP_REQUEST = "LOGIN_WITH_OTP_REQUEST";
export const LOGIN_WITH_OTP_SUCCESS = "LOGIN_WITH_OTP_SUCCESS";
export const LOGIN_WITH_OTP_FAILURE = "LOGIN_WITH_OTP_FAILURE";
export const CLEAR_LOGIN_WITH_OTP = "CLEAR_LOGIN_WITH_OTP";

export const VERIFY_OTP_REQUEST = "VERIFY_OTP_REQUEST";
export const VERIFY_OTP_SUCCESS = "VERIFY_OTP_SUCCESS";
export const VERIFY_OTP_FAILURE = "VERIFY_OTP_FAILURE";
export const CLEAR_VERIFY_OTP = "CLEAR_VERIFY_OTP";


export const RESEND_OTP_REQUEST = "RESEND_OTP_REQUEST";
export const RESEND_OTP_SUCCESS = "RESEND_OTP_SUCCESS";
export const RESEND_OTP_FAILURE = "RESEND_OTP_FAILURE";
export const CLEAR_RESEND_OTP = "CLEAR_RESEND_OTP";

